export { default } from 'components/Invoices/Invoices'
